<div *ngIf="pageLoad()" class="border-round border-1 surface-border p-4 surface-card">
    <span class="text-700 text-lg">Espera un momento ...</span>
    <div class="flex mb-3">
        <p-skeleton shape="circle" size="4rem" styleClass="mr-2" />
        <div>
            <p-skeleton width="10rem" styleClass="mb-2" />
            <p-skeleton width="5rem" styleClass="mb-2" />
            <p-skeleton height=".5rem" />
        </div>
    </div>
    <p-skeleton width="100%" height="150px" />
    <div class="flex justify-content-between mt-3">
        <p-skeleton width="4rem" height="2rem" />
        <p-skeleton width="4rem" height="2rem" />
    </div>
</div>
<p-card id="verNoProyectoCard" *ngIf="!pageLoad()&&!selected" header="">
    @defer {
    <div class="justify-content-center flex-wrap">
        <h3>Proyecto no encontrado...</h3>
        <div class="p-toolbar-group-end">
            <span class="p-2">
                <button (click)="goBack()" class="p-button-info" routerLinkActive="router-link-active" size="large"
                    pButton icon="pi pi-undo">Regresar</button>
            </span>
        </div>
    </div>
    } @loading () {
    <p-progressSpinner ariaLabel="loading" />
    }
</p-card>

<div id="verGlobalProyectoCard" *ngIf="selected">
    <div class="surface-card grid grid-nogutter border-round shadow-2 mb-6" *ngFor="let prj of proyectos">
        <div class="col-12 xl:col-10">
            <div class="card h-full">
                <ng-template #confirmarCarritoButtonTemplate let-clickEvent="clickEvent">
                    <p-button id="btnIrCarrito" icon="pi pi-shopping-cart text-2xl"
                        *ngIf="this.proyectoDataService.valitedButtonTemplate() && !esSeleccionable(prj)"
                        [routerLink]="['/users/pagos/tramites/', this.tramite.idProyecto()]"
                        [queryParams]="{sessionId: sessionId}" styleClass="p-button-info p-button-rounded ml-2"
                        pTooltip="Proceder a completar" (onClick)="clickEvent($event)"></p-button>
                </ng-template>
                <ng-template #initEvaluacionTemplate let-item let-clickEvent="clickEvent">
                    <p-confirmPopup />
                    <p-button
                        *ngIf="loginServices.hasRoles(['gerente']) && (this.selected?.idSolicitudEstado==2 || this.selected?.idSolicitudEstado==11)"
                        label="Iniciar evaluación" icon="pi pi-caret-right text-2xl"
                        styleClass="p-button-info p-button-rounded ml-2" pTooltip="Iniciar evaluación"
                        (click)="openDialogoEval($event,clickEvent)" />

                </ng-template>
                <app-generales-resumen [timelineEvents]="this.timelineEvents" [selected]="selected!"
                    [carritoButtomTemplate]="confirmarCarritoButtonTemplate"
                    [initEvaluacionTemplate]="initEvaluacionTemplate" (itemClickedEval)="handleItemClicked($event)" />
                <div>
                    <p-tabView [(activeIndex)]="activeIndex" (onChange)="onTabChange({event : $event})">

                        <!-- TABLA DE GENERALES -->
                        <p-tabPanel>
                            <ng-template pTemplate="header">
                                <i class="pi pi-book"></i>
                                <span class="pl-1">Generales</span>
                            </ng-template>
                            <ng-container *ngIf="loginServices.hasRoles(['gerente','tecnico_resolutor'])">
                                <app-informacion-general-cliente [prj]="prj"></app-informacion-general-cliente>
                            </ng-container>


                            <!-- Esta tab contiene los datos relacionados a los dowpdown de GENERAL -->
                            <app-generales-proyecto [prj]="prj" [isRegistroProfesional]="isRegistroProfesional"></app-generales-proyecto>



                            <div class="text-900 font-bold text-3xl mb-4 mt-2" [ngStyle]="{'padding': '1.5rem 0rem'}">
                                ({{ this.proyectoDataService.tramitesPorProyecto().length }}) Trámites
                            </div>
                            @defer {
                            <ng-template #btnIrTramite let-item let-clickEvent="clickEvent">
                                <p-button *ngIf="loginServices.hasRoles(['tecnico_resolutor','gerente'])"
                                          id="btnIrTramite"  icon="pi pi-arrow-right"
                                          label="Ir a trámite"
                                          styleClass="p-button-rounded p-button-secondary ml-1"
                                          pTooltip="Ir a trámite" (onClick)="initFormTramites($event,item)"></p-button>
                            </ng-template>
                            <app-tramites-por-proyecto
                                [datosCargados]="this.proyectoDataService.tramitesPorProyecto()!=null"
                                [tramitesPorProyecto]="this.proyectoDataService.tramitesPorProyecto()"
                                [btnTramites]="btnIrTramite"/>
                            } @loading () {
                            <p-progressSpinner ariaLabel="loading" />
                            }
                        </p-tabPanel>

                        <!-- TABLA DE ARCHIVOS -->
                        <p-tabPanel>
                            <ng-template pTemplate="header">
                                <i class="pi pi-file-edit"></i>
                                <span class="pl-1">Archivos</span>
                            </ng-template>
                            <p-table #dtfiles class="w-full" [value]="archivos"
                                styleClass="p-datatable-gridlines p-datatable-sm"
                                [globalFilterFields]="['nombre', 'tipoArchivo', 'estadoArchivo']"
                                [tableStyle]="{ 'min-width': '50rem' }">
                                <ng-template pTemplate="caption">
                                    <div class="flex">
                                        <p-iconField iconPosition="left" class="ml-auto">
                                            <p-inputIcon>
                                                <i class="pi pi-search text-2xl"></i>
                                            </p-inputIcon>
                                            <input #filterInput pInputText type="text"
                                                (input)="dtfiles.filterGlobal(filterInput.value, 'contains')"
                                                placeholder="Filtro global" />
                                        </p-iconField>
                                    </div>
                                </ng-template>
                                <ng-template pTemplate="header">
                                    <tr>
                                        <th>
                                            <p-columnFilter type="text" field="nombre" placeholder="Filtrar por nombre"
                                                ariaLabel="Filtrar por nombre" />
                                        </th>
                                        <th>
                                            <p-columnFilter type="text" field="tipoArchivo"
                                                placeholder="Filtrar por tipo de archivo"
                                                ariaLabel="Filtrar por tipo de archivo" />
                                        </th>
                                        <th>
                                            <p-columnFilter type="text" field="estadoArchivo"
                                                placeholder="Filtrar por estado" ariaLabel="Filtrar por estado" />
                                        </th>
                                        <th>Acción</th>
                                    </tr>
                                </ng-template>
                                <ng-template pTemplate="body" let-archivo>
                                    <tr>
                                        <td>
                                            <span class="font-bold ml-1">
                                                {{ archivo.nombre }}
                                            </span>
                                            <div class="flex justify-content-end flex-wrap">
                                                <div class="flex align-items-center justify-content-center">
                                                    <p-tag styleClass="text-xs" icon="pi pi-clock"
                                                        [value]="archivo.fechaCreacion"
                                                        [pTooltip]="'Fecha creacion de archivo'" />
                                                </div>
                                            </div>
                                        </td>
                                        <td>{{ archivo.tipoArchivo }}</td>
                                        <td>{{ archivo.estadoArchivo }}</td>
                                        <td>
                                            <p-button type="button" pRipple label=""
                                                      [disabled]="this.downloading()"
                                                      pTooltip="Clic para descargar archivo" icon="{{this.downloading()?'pi pi-spin pi-spinner':'pi pi-download'}}"
                                                      styleClass="p-button-rounded p-button-info"
                                                      (click)="this.downloadSigndFileNewTab(archivo.hash)" iconPos="right">
                                            </p-button>
                                            <p-button *ngIf="archivo.ext=='.jpeg' || archivo.ext=='.jpg' || archivo.ext=='.png'" type="button"
                                                pRipple label="" [pTooltip]="'Clic para visualizar archivo'+archivo.ext"
                                                icon="pi pi-image" styleClass="p-button-rounded p-button-primary"
                                                (click)="openFileInViewer(archivo,1)" iconPos="right">
                                            </p-button>
                                            <p-button *ngIf="archivo.ext=='.pdf'" type="button" pRipple label=""
                                                [pTooltip]="'Clic para visualizar archivo '+archivo.ext"
                                                icon="pi pi-file-pdf" styleClass="p-button-rounded p-button-primary"
                                                (click)="openFileInViewer(archivo,2)" iconPos="right">
                                            </p-button>
                                        </td>
                                    </tr>
                                </ng-template>
                            </p-table>
                        </p-tabPanel>

                        <!-- TABLA DE TECNICOS ASIGNADOS -->
                        <p-tabPanel *ngIf="loginServices.hasRoles(['ministro','gerente','jefe'])">
                            <app-knop [value]="totalProgress()" [size]="85" [label]="'Progreso total'"
                                [strokeWidth]="10" [customClass]="'flex flex-column'"></app-knop>
                            <ng-template #progresoKnob let-item let-clickEvent="clickEvent">
                                <app-knop [value]="item.progresoEval" [size]="55" [strokeWidth]="10"
                                    [customClass]="'flex'"></app-knop>
                            </ng-template>
                            <ng-template pTemplate="header">
                                <i class="pi pi-users"></i>
                                <span class="pl-1">Técnicos Asignados</span>
                            </ng-template>
                            <div class="text-900 font-bold text-3xl mb-4 mt-2">
                                <app-assigned-users [renderActions]="false" [renderKnobActions]="true"
                                    [progresoEvalTemplate]="progresoKnob" [assignedUsers]="assignedUsers()!">
                                </app-assigned-users>
                            </div>
                        </p-tabPanel>

                        <!-- TABLA DE REQUISITOS -->
                        <p-tabPanel>
                            <ng-template pTemplate="header">
                                <i class="pi pi-tags"></i>
                                <span class="pl-1">Requisitos</span>
                            </ng-template>
                            <div class="line-height-3 m-0 mb-4 mt-2">
                                <!--                                No es posible pasar el tramite como parametro ya que este proceso esta aplicando para todos los tramites vinculados al proyecto.-->
                                <!--                                En el perfil del proyecto, la consulta se realiza para todos los tramites. 09/01/2025-->
                                <solicitud-requisitos [requisitos]="tramite.requisitosFormularios()"
                                    [idProyecto]="this.tramite.idProyecto()!"
                                    [idSolicitud]="this.selected!.idSolicitud?.toString()!"
                                    [datosCargados]="tramite.datosCargados"></solicitud-requisitos>
                            </div>
                        </p-tabPanel>

                        <!-- TABLA DE EVALUACIONES -->
                        <p-tabPanel *ngIf="loginServices.hasRoles(['ministro','gerente','jefe'])">
                            <ng-template pTemplate="header">
                                <i class="pi pi-briefcase"></i>
                                <span class="pl-1">Evaluaciones</span>
                            </ng-template>
                            <div class="text-900 font-bold text-3xl mb-4 mt-2">
                                <app-solicitud-evaluaciones
                                    [idSolicitud]="this.selected!.idSolicitud?.toString()!"></app-solicitud-evaluaciones>
                            </div>
                        </p-tabPanel>

                        <!-- TABLA DE DICTAMENES -->
                        <p-tabPanel *ngIf="loginServices.hasRoles(['ministro','gerente','jefe'])">
                            <ng-template pTemplate="header">
                                <i class="pi pi-address-book"></i>
                                <span class="pl-1">Dictamenes</span>
                            </ng-template>
                            <div class="text-900 font-bold text-3xl mb-4 mt-2">
                                <app-dictamenes-evaluacion [selected]="this.selected!"></app-dictamenes-evaluacion>
                            </div>
                        </p-tabPanel>

                        <!-- TABLA DE RESOLUCIONES -->
                        <p-tabPanel *ngIf="loginServices.hasRoles(['ministro','gerente','jefe'])">
                            <ng-template pTemplate="header">
                                <i class="pi pi-briefcase"></i>
                                <span class="pl-1">Resoluciones</span>
                            </ng-template>
                            <div class="text-900 font-bold text-3xl mb-4 mt-2">
                                <app-resoluciones [selected]="this.selected!" [registro]="registroProfesional_Solicitud"></app-resoluciones>
                            </div>
                        </p-tabPanel>

                        <!-- TABLA DE DATOS DE SOLICITUD -->
                        <p-tabPanel *ngIf="isRegistroProfesional">

                            <ng-template pTemplate="header">
                                <i class="pi pi-book"></i>
                                <span class="pl-1">Datos de Solicitud</span>
                            </ng-template>


                            <!-- Mostrar mensaje si no existen -->
                            <div class="center"
                                *ngIf="!registroProfesional_Solicitud_Exist || !registroProfesional_Solicitud">
                                <p-message severity="info" text="No existen datos de su solicitud para mostrar."></p-message>
                            </div>


                            <!-- Mostrar datos si ya está cargado -->
                            <app-display-registro-profesional *ngIf="registroProfesional_Solicitud_Exist" [registro]="registroProfesional_Solicitud"></app-display-registro-profesional>


                        </p-tabPanel>

                        <!-- TABLA DE ANTECEDENTES -->
                        <p-tabPanel *ngIf="isRegistroProfesional">
                            <ng-template pTemplate="header">
                                <i class="pi pi-book"></i>
                                <span class="pl-1">Antecedentes</span>
                            </ng-template>

                            <!-- Mostrar mensaje si no existen -->
                            <div class="center"
                                *ngIf="!registroProfesional_Antecedentes_exist || registroProfesional_Antecedentes?.length == 0">
                                <p-message severity="info" text="No existen antecedentes para mostrar."></p-message>
                            </div>

                            <!-- Mostrar mapeando el array -->
                            <div
                                *ngIf="registroProfesional_Antecedentes_exist && registroProfesional_Antecedentes && registroProfesional_Antecedentes.length > 0">
                                <app-display-antecedentes *ngFor="let item of registroProfesional_Antecedentes"
                                    [registro]="item"></app-display-antecedentes>
                            </div>
                        </p-tabPanel>

                        <!-- TABLA TRAMITES EXCLUIDOS -->
                        <p-tabPanel *ngIf="verTramitesExclusiones()">
                            <ng-template pTemplate="header">
                                <i class="pi pi-ban"></i>
                                <span class="pl-1">Trámites Excluidos</span>
                            </ng-template>

                            <div class="center" *ngIf="!tramiteExclusiones || tramiteExclusiones.length === 0">
                                <p-message severity="info" text="No hay solicitudes excluidas para mostrar."></p-message>
                            </div>
                            <app-display-tramites-exclusion
                                *ngIf="exclusionesCargadas  && tramiteExclusiones.length > 0"
                                [exclusiones]="tramiteExclusiones"
                                (estadoActualizado)="onEstadoActualizado()">
                            </app-display-tramites-exclusion>
                        </p-tabPanel>
                    </p-tabView>
                </div>
            </div>
        </div>

        <div class="col-12 lg:col-6 xl:col-2">
            <div class="card h-full">
                <app-events-board [events]="this.events()"></app-events-board>
                <!-- <h5>(0) Resoluciones</h5>
                @defer {
                <ul class="list-none p-0 m-0">
                    <li class="mb-4 flex align-items-center">
                        <p-avatar label="" size="normal" shape="circle" styleClass="text-base font-bold"
                            [style]="{'background-color':'rgba(101, 214, 173, 0.1)', 'color': '#27AB83', 'border': '1px solid #65D6AD'}"></p-avatar>
                        <div class="ml-3">
                            <span class="block font-semibold" style="font-size: 0.8rem">CALIFICACIÓN DE LUGAR</span>
                            <span class="text-color-secondary block">Aprobado
                                <i class="pi pi-check p-1" style="font-size: 1rem; color:green"></i>
                            </span>
                        </div>
                    </li>
                    <li class="mb-4 flex align-items-center">
                        <p-avatar label="" size="normal" shape="circle" styleClass="text-base font-bold"
                            [style]="{'background-color':'rgba(101, 214, 173, 0.1)', 'color': '#27AB83', 'border': '1px solid #65D6AD'}"></p-avatar>
                        <div class="ml-3">
                            <span class="block font-semibold" style="font-size: 0.8rem">LINEA DE CONSTRUCCIÓN</span>
                            <span class="text-color-secondary block">Aprobado
                                <i class="pi pi-check p-1" style="font-size: 1rem; color:green"></i>
                            </span>
                        </div>
                    </li>
                    <li class="mb-4 flex align-items-center">
                        <p-avatar label="" size="normal" shape="circle" styleClass="text-base font-bold"
                            [style]="{'background-color':'rgba(101, 214, 173, 0.1)', 'color': '#27AB83', 'border': '1px solid #65D6AD'}"></p-avatar>
                        <div class="ml-3">
                            <span class="block font-semibold" style="font-size: 0.8rem">FACTIBILIDAD DE AGUAS
                                LLUVIAS</span>
                            <span class="text-color-secondary block">Aprobado
                                <i class="pi pi-check p-1" style="font-size: 1rem; color:green"></i>
                            </span>
                        </div>
                    </li>
                    <li class="mb-4 flex align-items-center">
                        <p-avatar label="" size="normal" shape="circle" styleClass="text-base font-bold"
                            [style]="{'background-color':'rgba(101, 214, 173, 0.1)', 'color': '#27AB83', 'border': '1px solid #65D6AD'}"></p-avatar>
                        <div class="ml-3">
                            <span class="block font-semibold" style="font-size: 0.8rem">REVISIÓN VIAL Y
                                ZONIFICACIÓN</span>
                            <span class="text-color-secondary block">Aprobado
                                <i class="pi pi-check p-1" style="font-size: 1rem; color:green"></i>
                            </span>
                        </div>
                    </li>
                    <li class="mb-4 flex align-items-center">
                        <p-avatar label="" size="normal" shape="circle" styleClass="text-base font-bold"
                            [style]="{'background-color':'rgba(255, 155, 155, 0.1)', 'color': '#CF1124', 'border': '1px solid #FF9B9B'}"></p-avatar>
                        <div class="ml-3">
                            <span class="block font-semibold" style="font-size: 0.8rem">PERMISO DE CONSTRUCCIÓN</span>
                            <span class="text-color-secondary block">Denegado
                                <i class="pi pi-lock p-1" style="font-size: 1rem; color:red"></i>
                                <i class="pi pi-comments p-1" style="font-size: 1rem"></i>
                            </span>
                        </div>
                    </li>
                    <li class="mb-4 flex align-items-center">
                        <p-avatar label="" size="normal" shape="circle" styleClass="text-base font-bold"
                            [style]="{'background-color':'rgba(255, 155, 155, 0.1)', 'color': '#CF1124', 'border': '1px solid #FF9B9B'}"></p-avatar>
                        <div class="ml-3">
                            <span class="block font-semibold" style="font-size: 0.8rem">PERMISO DE PARCELACIÓN O
                                URBANIZACIÓN</span>
                            <span class="text-color-secondary block">Denegado
                                <i class="pi pi-lock p-1" style="font-size: 1rem; color:red"></i>
                                <i class="pi pi-comments p-1" style="font-size: 1rem"></i>
                            </span>
                        </div>
                    </li>
                    <li class="mb-4 flex align-items-center">
                        <p-avatar label="" size="normal" shape="circle" styleClass="text-base font-bold"
                            [style]="{'background-color':'rgba(255, 155, 155, 0.1)', 'color': '#CF1124', 'border': '1px solid #FF9B9B'}"></p-avatar>
                        <div class="ml-3">
                            <span class="block font-semibold" style="font-size: 0.8rem">RECEPCIÓN DE PROYECTO DE
                                CONSTRUCCIÓN O URBANIZACIÓN</span>
                            <span class="text-color-secondary block">Denegado
                                <i class="pi pi-lock p-1" style="font-size: 1rem; color:red"></i>
                                <i class="pi pi-comments p-1" style="font-size: 1rem"></i>
                            </span>
                        </div>
                    </li>
                    <li class="mb-4 flex align-items-center">
                        <p-avatar label="" size="normal" shape="circle" styleClass="text-base font-bold"
                            [style]="{'background-color':'rgba(255, 155, 155, 0.1)', 'color': '#CF1124', 'border': '1px solid #FF9B9B'}"></p-avatar>
                        <div class="ml-3">
                            <span class="block font-semibold" style="font-size: 0.8rem">RECEPCIÓN DE PROYECTO DE
                                PARCELACIÓN</span>
                            <span class="text-color-secondary block">Denegado
                                <i class="pi pi-lock p-1" style="font-size: 1rem; color:red"></i>
                                <i class="pi pi-comments p-1" style="font-size: 1rem"></i>
                            </span>
                        </div>
                    </li>
                </ul>
                <button type="button" pButton pRipple class="w-full mt-3 " label="Ver Resolucion"
                    icon="pi pi-external-link" iconPos="right"></button>
                } @loading () {
                <p-progressSpinner ariaLabel="loading" />
                } -->
            </div>
        </div>
    </div>
</div>

<ng-container *ngIf="dialogPdfView">
    <app-viewer-pdf [dialogPdfView]="dialogPdfView" [viewer]="viewer" [_showLoader]="_showLoader"
        (onPdfEmitterClose)="closeViewerPdf($event)"></app-viewer-pdf>
</ng-container>
<ng-container *ngIf="displayImgView">
    <app-viewer-img [_displayImgView]="displayImgView" [viewer]="viewer" [_showLoader]="_showLoader"
        (onImgtEmitterClose)="closeViewerImg($event)"></app-viewer-img>
</ng-container>

<ng-container *ngIf="openDialogEvaluacion">
    <app-fase-tramite-evaluacion [visible]="openDialogEvaluacion" [selected]="selected!" [evaluacion]="evaluacion"
        [datosCargados]="evaluacionesService.datosCargados" [loading]="loadingTemplate"
        (closeDialogEvent)="closeDialogEvaluacion()">
    </app-fase-tramite-evaluacion>
    <ng-template #loadingTemplate class="flex align-items-center flex-wrap">
        <div class="flex justify-content-center flex-wrap">
            <p-progressSpinner></p-progressSpinner>
        </div>
    </ng-template>
</ng-container>
